import { REQUEST_STATUS, REQUEST_TYPE, type RequestStatus, type RequestType } from '@hotel-voice/shared';
import type { RequestItem } from '@/types';

/** How a status reads to a guest, and which badge tone it takes. */
export const STATUS_PRESENTATION: Record<
  RequestStatus,
  { label: string; variant: 'secondary' | 'default' | 'success' | 'warning' | 'destructive' }
> = {
  [REQUEST_STATUS.REQUESTED]: { label: 'Requested', variant: 'secondary' },
  [REQUEST_STATUS.ACCEPTED]: { label: 'Accepted', variant: 'default' },
  [REQUEST_STATUS.IN_PROGRESS]: { label: 'In progress', variant: 'warning' },
  [REQUEST_STATUS.COMPLETED]: { label: 'Completed', variant: 'success' },
  [REQUEST_STATUS.CANCELLED]: { label: 'Cancelled', variant: 'destructive' },
  [REQUEST_STATUS.REJECTED]: { label: 'Declined', variant: 'destructive' },
};

export const TYPE_LABEL: Record<RequestType, string> = {
  [REQUEST_TYPE.HOUSEKEEPING]: 'Housekeeping',
  [REQUEST_TYPE.LAUNDRY]: 'Laundry',
  [REQUEST_TYPE.RESTAURANT]: 'Restaurant',
  [REQUEST_TYPE.STORE]: 'Store',
};

/** "Masala Dosa ×2, Coffee" — or the note when a housekeeping ask had no lines. */
export function summarizeItems(items: readonly RequestItem[], note?: string, max = 3): string {
  if (items.length === 0) return note?.trim() || 'Custom request';
  const parts = items
    .slice(0, max)
    .map((item) => (item.quantity > 1 ? `${item.name} ×${item.quantity}` : item.name));
  const remaining = items.length - max;
  return remaining > 0 ? `${parts.join(', ')} +${remaining} more` : parts.join(', ');
}

/** Only a REQUESTED request can be withdrawn by the guest; after that, ask the desk. */
export function canGuestCancel(status: RequestStatus): boolean {
  return status === REQUEST_STATUS.REQUESTED;
}
